export const CONTACT_CATEGORIES = {
  'Family & Community': [
    'Family Member Owner / Co-owner',
    'Family Member User (non-owner)',
    'Seasonal / Long-term Tenant',
    'Trusted Person / Caretaker',
    'Direct Neighbor (Emergency Contact)',
    'Condominium Trustee (if applicable)',
  ],
  'Professionals & Services': [
    'Plumber',
    'Electrician',
    'Mason',
    'Roofer',
    'Heating Engineer / Boiler Maintenance',
    'Glazier',
    'Locksmith / Metalworker',
    'Architect',
    'Project Manager / Works Supervisor',
    'Interior Decorator',
    'Gardener / Landscaper',
    'Cleaning Lady / Cleaning Service',
    'Concierge / Home Help',
    'Antenna Installer / TV Installation',
    'Alarm Installation / Home Automation',
    'Pool Maintenance',
    'Chimney Sweep',
    'Garage / Mechanic (if shared vehicles)',
    'Electricity Supplier',
    'Gas Supplier',
    'Water Supplier',
    'Fuel / Wood / Pellets Supplier',
    'Internet Service Provider (ISP)',
    'Phone / TV Operator',
    'Bank / Shared Property Account',
    'Home Insurance',
    'Grocery Delivery / Local Caterer',
    'Notary (for succession / transmission)',
    'Wealth Management Advisor',
    'Lawyer (Real Estate, Family Law)',
    'Accountant / Tax Specialist',
    'Real Estate Agent / Rental Manager',
    'Professional Rental Manager (Agency)',
    'Bailiff',
    'Shipyard / Wintering',
    'Marine Mechanic',
    'Harbor Master / Marina',
    'Fittings / Equipment Supplier',
    'Marine Insurance (Boat)',
    'RV Dealer / Repairer',
    'Technical Inspection (RV)',
    'Vehicle Insurance (RV)',
    'Forestry Expert / Silvicultural Manager',
    'Forestry Cooperative / Wood Buyer',
    'Surveyor / Land Expert',
    'Veterinarian (Equine or General)',
    'Farrier',
    'Stable / Equestrian Center (Boarding)',
    'Animal Feed Supplier',
    'Equine / Animal Insurance',
    'Animal Trainer / Behaviorist',
  ],
  'Emergencies & Institutions': [
    'Firefighters',
    'Police / Gendarmerie',
    'Local General Practitioner',
    'Hospital / Clinic',
    'Pharmacy',
    'Town Hall / Municipal Services',
  ],
} as const;

export type ContactCategory = keyof typeof CONTACT_CATEGORIES;
export type ContactSubCategory = (typeof CONTACT_CATEGORIES)[ContactCategory][number];

export const CONTACT_CATEGORY_KEYS = Object.keys(CONTACT_CATEGORIES) as ContactCategory[];

export const ALL_CONTACT_SUBCATEGORIES = Object.values(CONTACT_CATEGORIES).flat();
